import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonComponent } from './radio-button.component';
import { RadioButtonGroupComponent } from './radio-button-group.component';

@NgModule({
  declarations: [RadioButtonComponent, RadioButtonGroupComponent],
  imports: [CommonModule],
  exports: [RadioButtonComponent, RadioButtonGroupComponent],
})
export class RadioButtonModule {}
